export const getData = state => state.trackAssetModal.get('data');



/** WEBPACK FOOTER **
 ** ./src/selectors/track-asset-modal-selectors.js
 **/